/**
 * Public homeowner sign-up checks. CommonJS only. No object spread.
 */

const { HOMEOWNER_CONSENT_ERROR } = require('./consentCopy');

const SIGNUP_DUPLICATE_MESSAGE = 'This email already has an account. Sign in.';
const SIGNUP_CODE_MESSAGE = "That sponsor code isn't valid.";

function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

function splitPersonName(name) {
  const cleaned = String(name || '').replace(/\s+/g, ' ').trim();
  if (!cleaned) return { first: '', last: '' };
  const space = cleaned.indexOf(' ');
  if (space === -1) return { first: cleaned.slice(0, 80), last: '' };
  return {
    first: cleaned.slice(0, space).slice(0, 80),
    last: cleaned.slice(space + 1).trim().slice(0, 80),
  };
}

function normalizeSponsorCode(value) {
  return String(value || '').trim().toUpperCase();
}

function finishSignupAddressPatch(home, body) {
  const existingAddress = home && home.address;
  if (String(existingAddress || '').trim()) return null;
  const source = body || {};
  return {
    address: String(source.address || '').trim(),
    city: String(source.city || '').trim(),
    state: String(source.state || '').trim().slice(0, 40),
    zip_code: String(source.zip || source.zipCode || '').replace(/\D/g, '').slice(0, 5),
  };
}

function signupFieldErrors(input) {
  const source = input || {};
  const errors = [];
  const email = normalizeEmail(source.email);
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || email.length > 254) {
    errors.push('Enter a valid email.');
  }
  if (!String(source.name || '').trim()) errors.push('Enter your name.');
  if (String(source.password || '').length < 8) errors.push('Password must be at least 8 characters.');
  if (!String(source.address || '').trim()) errors.push('Enter the home address.');
  if (!String(source.city || '').trim()) errors.push('Enter the city.');
  const state = String(source.state || '').trim();
  if (!state) errors.push('Enter the state.');
  const zip = String(source.zip || source.zipCode || '').replace(/\D/g, '').slice(0, 5);
  if (zip.length < 5) errors.push('Enter a 5-digit ZIP code.');
  if (source.accepted !== true) errors.push(HOMEOWNER_CONSENT_ERROR);
  const code = normalizeSponsorCode(source.sponsorCode);
  if (code && !/^[A-Z0-9]{6}$/.test(code)) errors.push('Sponsor code must be 6 characters.');
  return errors;
}

module.exports = {
  SIGNUP_DUPLICATE_MESSAGE,
  SIGNUP_CODE_MESSAGE,
  normalizeEmail,
  splitPersonName,
  normalizeSponsorCode,
  finishSignupAddressPatch,
  signupFieldErrors,
};
